/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Untitled_JobInputs */

const en_applications_untitled_job = /** @type {(inputs: Applications_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled Job`)
};

const de_applications_untitled_job = /** @type {(inputs: Applications_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbenannte Stelle`)
};

const fr_applications_untitled_job = /** @type {(inputs: Applications_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emploi sans titre`)
};

const es_applications_untitled_job = /** @type {(inputs: Applications_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleo sin título`)
};

const it_applications_untitled_job = /** @type {(inputs: Applications_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro senza titolo`)
};

const nl_applications_untitled_job = /** @type {(inputs: Applications_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baan zonder titel`)
};

const pl_applications_untitled_job = /** @type {(inputs: Applications_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praca bez tytułu`)
};

const fi_applications_untitled_job = /** @type {(inputs: Applications_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nimetön työpaikka`)
};

const da_applications_untitled_job = /** @type {(inputs: Applications_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job uden titel`)
};

const sv_applications_untitled_job = /** @type {(inputs: Applications_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namnlöst jobb`)
};

/**
* | output |
* | --- |
* | "Untitled Job" |
*
* @param {Applications_Untitled_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_untitled_job = /** @type {((inputs?: Applications_Untitled_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Untitled_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_untitled_job(inputs)
	if (locale === "fr") return fr_applications_untitled_job(inputs)
	if (locale === "es") return es_applications_untitled_job(inputs)
	if (locale === "it") return it_applications_untitled_job(inputs)
	if (locale === "nl") return nl_applications_untitled_job(inputs)
	if (locale === "pl") return pl_applications_untitled_job(inputs)
	if (locale === "fi") return fi_applications_untitled_job(inputs)
	if (locale === "da") return da_applications_untitled_job(inputs)
	if (locale === "sv") return sv_applications_untitled_job(inputs)
	return en_applications_untitled_job(inputs)
});